import styled from 'styled-components'

export const Wrapper = styled.div``
export const AddressContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  line-height: 24px;

  & > svg {
    margin-right: 8px;
    color: ${({ theme }) => theme.colourPalette?.primaryColour || 'var(--brand-primary)'};
  }

  & > a {
    color: var(--brand-secondary);
    font-weight: var(--font-regular);
  }
`
export const Map = styled.div`
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  height: 400px;
`
